export default {
    name: 'QAccordion',
    model: {
        prop: 'visible',
        event: 'input',
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        transition: {
            type: String,
            default: 'fade'
        }
    },
    emits: ['input'],
    data() {
        return {
            show: this.visible
        };
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        },
        show(newVal) {
            this.$emit('input', newVal);
        }
    }
};
